var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaybar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(-846.29 -2642.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(560 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(10.529 9.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1576128901571183078",
    "data-name": 1576128901571183000,
    transform: "translate(896.087 2707.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M32.485,36.685v-26.4A5.3,5.3,0,0,0,27.2,5h0a5.3,5.3,0,0,0-5.281,5.281V44.606L14,30.876a5,5,0,0,0-7.393-1.584h0a4.93,4.93,0,0,0-1.848,6.073h0A104.849,104.849,0,0,0,23.244,66.786",
    transform: "translate(-4.341 0.281)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M15,39.966V8.281A5.3,5.3,0,0,1,20.281,3h0a5.3,5.3,0,0,1,5.281,5.281V39.966",
    transform: "translate(13.144 -3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M19,36.685v-26.4A5.3,5.3,0,0,1,24.281,5h0a5.3,5.3,0,0,1,5.281,5.281v26.4",
    transform: "translate(19.706 0.281)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M23,33.4V12.281A5.3,5.3,0,0,1,28.281,7h0a5.3,5.3,0,0,1,5.281,5.281V33.4h0a74.522,74.522,0,0,1-6.337,30.365",
    transform: "translate(26.267 3.562)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M912.132,2733.379s-39.7-21.756-10.878-41.065,34.266-10.062,43.784,2.448,31.274,20.94,22.572,29.915-10.878,10.334-10.878,10.334",
    transform: "translate(0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaybar);
export default __webpack_public_path__ + "static/media/claybar.acbd95a688416965943905ec6d3d8029.svg";
export { ForwardRef as ReactComponent };